module.exports = __webpack_public_path__ + "static/img/cdb2.ffc7a477.png";